import { displayMatchTypes, numericComparisonMatchTypes } from '@/common/components/MatchTypeEditor/constants'

export const amountFieldConfig = { matchTypes: numericComparisonMatchTypes }

export const incompleteBoundLabel = '…'

export const singleValueLabelPrefixes = {
  [displayMatchTypes.is]: '',
  [displayMatchTypes.greaterThan]: '> ',
  [displayMatchTypes.lowerThan]: '< ',
}

export const singleValueMatchTypeToConfigKey = {
  [displayMatchTypes.is]: 'eq',
  [displayMatchTypes.greaterThan]: 'gt',
  [displayMatchTypes.lowerThan]: 'lt',
  [displayMatchTypes.valueInRange]: null,
}
